module.exports = __webpack_public_path__ + "static/media/bg4.056eb058.jpg";